<template>
  <div class="page-wrapper">
    <div class="header-container">
      <div class="header-left">
        <p class="sys-name">陕西省建设工程造价数据监测平台</p>
      </div>
      <div class="header-right">
        <UserCenter></UserCenter>
      </div>
    </div>

    <div class="page-container">
      <div class="bg"></div>
      <div class="left-navBar">
        <LeftNavBar />
      </div>
      <div class="right-page">
        <transition name="page-transition">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
        </transition>
        <transition name="page-transition">
          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import LeftNavBar from "./nav/leftNavBar.vue";
import UserCenter from "./nav/userCenter.vue";
import { initWebSocket, closeWebSocket } from "@/util/webSokt";
export default {
  components: { LeftNavBar, UserCenter },
  props: {},
  data() {
    return {
      transition: false
    };
  },
  computed: {},
  watch: {},
  created() {
    initWebSocket();
  },
  mounted() { },

  methods: {}
};
</script>
<style scoped lang='scss'>
.page-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #F3F4F7;

  .header-container {
    height: 60px;
    background-color: #165dff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    z-index: 10;

    .header-left {
      .sys-name {
        color: #ffffff;
        font-size: 30px;
        font-weight: 500;
        margin: 0;
        display: flex;
        align-items: center;
        gap: 10px;

        // &::before {
        //   content: "";
        //   display: inline-block;
        //   width: 24px;
        //   height: 24px;
        //   background-color: #ffffff;
        //   border-radius: 4px;
        //   // background-image: url("~@/assets/images/logo.png");
        //   background-size: contain;
        //   background-repeat: no-repeat;
        //   background-position: center;
        // }
      }
    }

    .header-right {
      ::v-deep .user-center {
        color: #ffffff;
        transition: all 0.2s ease;

        &:hover {
          opacity: 0.9;
        }
      }
    }
  }

  .page-container {
    flex: 1;
    display: flex;
    overflow: hidden;
    position: relative;

    .bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      // background-image: url("~@/assets/images/bg/home_bg.jpg");
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      opacity: 0.1;
      z-index: 1;
      transition: opacity 0.5s ease;
    }

    .left-navBar {
      width: auto;
      background-color: #001529;
      box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
      z-index: 9;
      transition: all 0.3s ease;

      ::v-deep .el-menu {
        border-right: none;
      }

      ::v-deep .el-menu-item {
        transition: all 0.2s ease;
      }

      ::v-deep .el-menu-item:hover,
      ::v-deep .el-menu-item.is-active {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }

    .right-page {
      flex: 1;
      overflow-y: auto;
      padding: 20px;
      z-index: 9;
      transition: all 0.3s ease;

      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }

      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #c1c1c1;
        border-radius: 10px;
        transition: background-color 0.2s ease;
      }

      &::-webkit-scrollbar-thumb:hover {
        background-color: #a8a8a8;
      }
    }
  }
}

// 页面切换过渡动画
.page-transition-enter-active,
.page-transition-leave-active {
  transition: all 0.4s ease;
}

.page-transition-enter,
.page-transition-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

// 响应式设计
@media (max-width: 1200px) {
  .left-navBar {
    // width: 64px !important;
  }

  .right-page {
    width: 1000px;
    padding: 15px;
  }
}

@media (max-width: 768px) {
  // .page-container {
  //   position: relative;
  // }

  // .left-navBar {
  //   position: absolute;
  //   left: 0;  
  //   top: 0;
  //   height: 100%;
  //   transform: translateX(-100%);
  //   z-index: 100;

  //   &.nav-open {
  //     transform: translateX(0);
  //   }
  // }

  // .menu-toggle {
  //   display: block !important;
  // }

  // .right-page {
  //   margin-left: 0 !important;
  //   padding: 15px 10px;
  // }

  // .header-container .header-left .sys-name {
  //   font-size: 16px;
  // }
}

// 移动端菜单切换按钮
.menu-toggle {
  display: none;
  position: fixed;
  left: 15px;
  top: 70px;
  width: 40px;
  height: 40px;
  background-color: #165dff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  z-index: 99;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }
}
</style>
